import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"
import toast from 'react-hot-toast';
import { logout } from './userSlice';


export const initialState = {
  dashboard: {
    analytics: [],
    appointments: [],
  },
  reportStats: {
    total_requests: 0,
    covered_requests: 0,
    uncovered_requests: 0,
    avg_time_to_cover: 0,
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {
    setDashboardAnalytic: (state, { payload }) => {
      state.dashboard = payload?.data ?? payload;
    },
    setDashboardAnalytics: (state, { payload }) => {
      state.dashboard.analytics = payload;
    },
    setDashboardAppointments: (state, { payload }) => {
      state.dashboard.appointments = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllDashboard: (state, { payload }) => {
      state.loader = payload
    },
    setReportStats: (state, { payload }) => {
      state.reportStats = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchClientDashboardAnalytics(params)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if (result?.status == 401) {
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchClientDashboardAppointment(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setDashboardAppointments(result.data.data));
      } else {
        dispatch(setDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if (result?.status == 401) {
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}



export const downloadDashboardAppointmentsCSV = (params) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const response = await Api.exportDashboardAppointments(params);
    if (response.status >= 200 && response.status < 300) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `appointments_${new Date().toISOString().split("T")[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("CSV Downloaded Successfully", {
        className: "successToast",
      });
    } else {
      toast.error("Failed to download CSV", {
        className: "errorToast",
      });
    }
  } catch (error) {
    console.log("error", error);
    toast.error("An error occurred during download", {
      className: "errorToast",
    });
  }
  dispatch(setLoader(false));
};

export const fetchReportStats = (params) => async (dispatch) => {
  try {
    const result = await Api.fetchClientDashboardReportStats(params)
    if (result?.status >= 200 && result?.status < 300) {
      dispatch(setReportStats(result.data.data));
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const { setDashboardAnalytics, clearAllDashboard, setLoader, setError, setDashboardAppointments, setReportStats } = dashboardSlice.actions

export default dashboardSlice.reducer
export const DashboardSelector = state => state.dashboard



